import ShowingsOverview from './ShowingsOverview'

export default ShowingsOverview
